import Skeleton from "react-loading-skeleton";

const ProductListingLoadingState = () => {
	return (
		<div className="grid gap-4">
			<Skeleton count={4} height={100} className="rounded-lg" />
		</div>
	);
};

export default ProductListingLoadingState;
